// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".signIn-root-0rg {\n    display: grid;\n}\n\n.signIn-form-O-4 {\n}\n\n.signIn-modal-nbf {\n    visibility: hidden;\n    height: 100%;\n    width: 100%;\n    background-color: rgb(var(--venia-global-color-gray));\n    text-align: center;\n    position: relative;\n    bottom: 0;\n}\n\n.signIn-modal_active-5oW {\n    visibility: visible;\n    opacity: 0.9;\n}\n\n.signIn-buttonsContainer-aiT {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "signIn-root-0rg col-span-12 lg_col-span-3",
	"form": "signIn-form-O-4 grid gap-y-6",
	"modal": "signIn-modal-nbf",
	"modal_active": "signIn-modal_active-5oW signIn-modal-nbf col-span-12 lg_col-span-4",
	"buttonsContainer": "signIn-buttonsContainer-aiT flex justify-between items-center"
};
export default ___CSS_LOADER_EXPORT___;
